<div id="beyond">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">IH Competitions</h4>
                  <div class="card-body">
                    <p class="inner-lead">At our school, we offer a variety of opportunities for students to participate in competitions, including Olympiads and other academic competitions. These competitions provide students with the opportunity to challenge themselves and showcase their skills.
                    </p>  
                    <p class="inner-lead">We believe that participating in IH competitions is an important part of the learning process, and helps students develop critical thinking skills, problem-solving skills, and a passion for learning.</p>
                    <p class="inner-lead">At our school, we are committed to providing our students with a well-rounded education that goes beyond the traditional classroom setting. Our competitions offer a range of opportunities for students to participate in various academic and non-academic competitions. These competitions are designed to challenge students and help them develop their critical thinking, problem-solving, and teamwork skills.
                    </p>
                    <p class="inner-lead">Participating in these competitions is not only beneficial for our students' academic growth, but also their personal growth. Our students learn valuable life skills, such as perseverance, dedication, and sportsmanship, that will serve them well in all aspects of their lives.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>